import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getListProduct(params) {
	return client.get("product/list", {
		params: params,
	});
}

function getSeriesProduct(params) {
	return client.get("product/series", {
		params: params,
	});
}

function getPackagesProduct(params) {
	return client.get("general/package", {
		params: params,
	});
}

function getDetailProduct(params) {
	return client.get("product/detail", {
		params: params,
	});
}

export default {
	getListProduct,
	getSeriesProduct,
	getPackagesProduct,
	getDetailProduct
};